import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-project-task-review-popup',
  templateUrl: './project-task-review-popup.component.html',
  styleUrls: ['./project-task-review-popup.component.scss']
})
export class ProjectTaskReviewPopupComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
